<!-- header start -->
<header
	class="sticky"
	[ngClass]="class">
	<div class="mobile-fix-option"></div>
	<div
		class="top-header"
		*ngIf="true">
		<div class="container">
			<div class="row">
				<div class="col-lg-6">
					<div class="header-contact">
						<ul>
							<li>

								<app-cms [slug]="'home-intro'"></app-cms>

							</li>
						</ul>
					</div>
				</div>
				<div class="col-lg-6 text-end">
					<ul class="header-dropdown">
						<li
							class="compare"
							*ngIf="false">
							<a [routerLink]="['/shop/compare']">
								<i
									class="fa fa-random"
									aria-hidden="true"></i>
								Compare
							</a>
						</li>
						<li class="mobile-wishlist wishlist-link">
							<a [href]="baseURL + '/shop/wishlist'">
								<i
									class="fa fa-heart"
									aria-hidden="true"></i>
								<span class="link-title">Wishlist</span>
							</a>
						</li>
						<li
							class="mobile-account ms-2 account-link"
							[ngClass]="{'onhover-dropdown': loggedUser && !ismobile}">
							<a
								[routerLink]="['/user/signin']"
								*ngIf="!loggedUser">
								<i
									class="fa fa-user"
									aria-hidden="true"></i>
								<span class="link-title">{{'buttons.login' | translate}}</span>
							</a>
							<a *ngIf="loggedUser && !ismobile">{{loggedUser.description}}</a>
							<a *ngIf="loggedUser && ismobile">{{loggedUser.description}}</a>
							<!-- My Account -->
							<ul
								*ngIf="loggedUser && !ismobile"
								class="onhover-show-div">

								<li>
									<a (click)="logout()">Logout</a>
								</li>
							</ul>
						</li>

					</ul>
				</div>
			</div>
		</div>
	</div>
	<div
		class="container"
		*ngIf="true">
		<div class="row">
			<div class="col-sm-12">
				<div class="main-menu border-section border-top-0">
					<div class="brand-logo layout2-logo">
						<a href="{{baseURL}}">
							<!-- <img
								[src]="themeLogo"
								class="img-fluid"
								alt="logo"> -->
							<img
								src="assets/images/icon/{{logo}}"
								class="img-fluid"
								alt="logo">
						</a>
					</div>
					<div class="title">
						<h2>{{'usertitle' | translate}}</h2>
					</div>
					<div class="menu-right pull-right">
						<ul>
							<li>
								<a href="{{baseURL}}">
									{{'backtoshop' | translate}}
									<i class="fas fa-exchange-alt"></i>
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div
		class="unique-header"
		*ngif="false">
		<div class="container">
			<div class="row">
				<div class="brand-logo layout2-logo col">
					<a href="{{baseURL}}">
						<!-- <img
								[src]="themeLogo"
								class="img-fluid"
								alt="logo"> -->
						<img
							src="assets/images/icon/{{logo}}"
							class="img-fluid"
							alt="logo">
					</a>
					<ul>
						<li>
							<a href="{{baseURL}}">
								{{'backtoshop' | translate}}
								<i class="fas fa-exchange-alt"></i>
							</a>
						</li>
					</ul>
				</div>

				<div class="right-menu col">
					<ul class="header-dropdown">
						<li
							class="compare"
							*ngIf="false">
							<a [routerLink]="['/shop/compare']">
								<i
									class="fa fa-random"
									aria-hidden="true"></i>
								Compare
							</a>
						</li>
						<li class="mobile-wishlist wishlist-link">
							<a [href]="baseURL + '/shop/wishlist'">
								<i
									class="fa fa-heart"
									aria-hidden="true"></i>
								<span class="link-title">Wishlist</span>
							</a>
						</li>
						<li
							class="mobile-account ms-2 account-link"
							[ngClass]="{'onhover-dropdown': loggedUser && !ismobile}">
							<a
								[routerLink]="['/user/signin']"
								*ngIf="!loggedUser">
								<i
									class="fa fa-user"
									aria-hidden="true"></i>
								<span class="link-title">{{'buttons.login' | translate}}</span>
							</a>
							<a *ngIf="loggedUser && !ismobile">{{loggedUser.initials}}</a>
							<a *ngIf="loggedUser && ismobile">{{loggedUser.initials}}</a>
							<!-- My Account -->
							<ul
								*ngIf="loggedUser && !ismobile"
								class="onhover-show-div">

								<li>
									<a (click)="logout()">Logout</a>
								</li>
							</ul>
						</li>

					</ul>
				</div>
			</div>
		</div>
		<div class="title col">
			<h1>{{'usertitle' | translate}}</h1>
		</div>
	</div>

</header>
<!-- header end -->
